import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Modal,
  Paper,
  IconButton,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Busy from "../../assets/busy.png";

const BusyMachineModal = ({ setBusyPopupFlag , machineError}) => {
  const [timer, setTimer] = useState(120); // 2 minutes in seconds

  // Timer runs continuously
  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((prev) => (prev > 0 ? prev - 1 : 120)); // reset after reaching 0
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const formatTime = (seconds) => {
    const m = String(Math.floor(seconds / 60)).padStart(2, "0");
    const s = String(seconds % 60).padStart(2, "0");
    return `${m}:${s}`;
  };
const handleClose=(e)=>{

setBusyPopupFlag(false)
}
  return (
    <Modal
      open={true}
      sx={{
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "center",
        p: 2,
      }}
    >
      <Box sx={{ position: "relative", width: "100%", maxWidth: 400 ,    bottom: "-15px"}}>
        <Box>
        {/* Floating Close Button */}
        <IconButton
          onClick={(e)=>{handleClose(e)}}
          sx={{
            position: "absolute",
           
                top: "-51px",
    right:" 44%",
            zIndex: 10,
            backgroundColor: "white",
            boxShadow: 2,
            "&:hover": {
              backgroundColor: "white",
              color: "black",
            },
          }}
        >
          <CloseIcon />
        </IconButton>
        </Box>

        <Paper
          elevation={4}
          sx={{
            width: "100%",
            borderRadius: "16px 16px 0 0",
            textAlign: "center",
            position: "relative",
            p: 3,
            pb: 5,
          }}
        >
          {/* Image */}
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Box
              component="img"
              src={Busy}
              alt="Vending Machine"
              sx={{ width: "60%", maxHeight: 150, mb: 2 }}
            />
          </Box>

          {/* Title */}
          <Typography variant="h6" color="error" gutterBottom>
            Oops!
          </Typography>
          <Typography variant="body1" gutterBottom>
            Machine is {machineError}.
            <br />
            Please try again in:
          </Typography>

          {/* Timer */}
          <Button
            variant="contained"
            color="error"
            sx={{
              mt: 2,
              fontWeight: "bold",
              fontSize: "1.5rem",
              pointerEvents: "none",
              color:"#583C43",
              background:" #D9D9D9",
border:"1px solid #583C4366"
            }}
          >
            {formatTime(timer)}
          </Button>

          {/* Try Again Button */}
  {/*         <Button
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 3, py: 1 }}
            onClick={onTryAgain}
          >
            Try Again
          </Button> */}
        </Paper>
      </Box>
    </Modal>
  );
};

export default BusyMachineModal;
